'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomFormsController = function () {
  function CustomFormsController(authService, printService, lookupService, $scope, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CustomFormsController);
    this.authService = authService;
    this.printService = printService;
    this.lookupService = lookupService;
    this.$scope = $scope;
    this.enums = enums;

    this.authService.getLocationExtendedProperties('customForms');

    this.loadAllBrands();

    this.customForms = [];

    this.$scope.$on('enquiry:initialized', this.selectCustomForms.bind(this));
  }

  (0, _createClass3.default)(CustomFormsController, [{
    key: 'loadAllBrands',
    value: function loadAllBrands() {
      var _this = this;

      this.lookupService.lookupBrands().then(function (brands) {
        _this.brands = brands;
      });
    }
  }, {
    key: 'selectCustomForms',
    value: function selectCustomForms() {
      var _this2 = this;

      this.customForms = (0, _lodash.filter)(this.authService.authData.currentLocation.customForms, function (o) {
        return _this2.show(o.condition);
      });
    }
  }, {
    key: 'action',
    value: function action(actionName) {
      if (actionName === 'viewDns') {
        this.viewDns();
      } else if (actionName === 'viewMercPerOwnedWarranty') {
        this.viewMercPerOwnedWarranty();
      } else if (actionName === 'viewMercSPA') {
        this.viewMercSPA();
      } else if (actionName === 'viewMercPreOwnedSPA') {
        this.viewMercPreOwnedSPA();
      } else if (actionName === 'viewMercDPA') {
        this.viewMercDPA();
      } else if (actionName === 'viewMSLPreOwnedDPA') {
        this.viewMSLPreOwnedDPA();
      } else if (actionName === 'viewMazdaDPA') {
        this.viewMazdaDPA();
      } else if (actionName === 'viewSkodaDPA') {
        this.viewSkodaDPA();
      } else if (actionName === 'viewRf105Form') {
        this.viewRf105Form();
      } else if (actionName === 'viewRf105TradeForm') {
        this.viewRf105TradeForm();
      } else if (actionName === 'viewMslBydDpa') {
        this.viewMslBydDpa();
      } else if (actionName === 'viewOrderConfirmation') {
        this.viewOrderConfirmation();
      } else if (actionName === 'viewCunninghamOrderForm') {
        this.viewCunninghamOrderForm();
      } else if (actionName === 'viewDistanceSellingAddendum') {
        this.viewDistanceSellingAddendum();
      } else if (actionName === 'viewMSL_PCP') {
        this.viewMSL_PCP();
      } else if (actionName === 'viewMslPreOwnedWarrantyAgreement') {
        this.viewMslPreOwnedWarrantyAgreement();
      } else if (actionName === 'viewMslXpengDpa') {
        this.viewMslXpengDpa();
      } else if (actionName === 'viewSuzukiDataForm') {
        this.viewSuzukiDataForm();
      } else if (actionName === 'viewLyonsPrepWorkForm') {
        this.viewLyonsPrepWorkForm();
      }
    }
  }, {
    key: 'show',
    value: function show(condition) {
      if (condition === 'showDns') {
        return !this.forTrader() && this.isRetailEnquiry();
      } else if (condition === 'showMercPerOwnedWarranty') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('Used');
      } else if (condition === 'showMercSPA' || condition === 'showMercDPA') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('New');
      } else if (condition === 'showMercPreOwnedSPA') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('mercedes-benz') && this.vehicleHasCondition('Used');
      } else if (condition === 'showMSLPreOwnedDPA') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasCondition('Used');
      } else if (condition === 'showMslBydDpa') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('BYD') && this.vehicleHasCondition('New');
      } else if (condition === 'showMazdaDPA') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Mazda') && this.vehicleHasCondition('New');
      } else if (condition === 'showSkodaDPA') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Skoda') && this.vehicleHasCondition('New');
      } else if (condition === 'showRf105Form') {
        return !this.forTrader() && this.enquiry.tradeInVehicles.length > 0;
      } else if (condition === 'showRf105TradeForm') {
        return this.forTrader();
      } else if (condition === 'showOrderConfirmation') {
        return !this.forTrader() && this.isRetailEnquiry();
      } else if (condition === 'showCunninghamOrderForm') {
        return !this.forTrader() && this.isRetailEnquiry();
      } else if (condition === 'showDistanceSellingAddendum') {
        return !this.forTrader() && this.isRetailEnquiry();
      } else if (condition === 'showMSL_PCP') {
        return !this.forTrader() && this.isRetailEnquiry();
      } else if (condition === 'showMslPreOwnedWarrantyAgreement') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasCondition('Used');
      } else if (condition === 'showMslXpengDpa') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Xpeng') && this.vehicleHasCondition('New');
      } else if (condition === 'showSuzukiDataForm') {
        return !this.forTrader() && this.isRetailEnquiry() && this.vehicleHasBrand('Suzuki');
      } else if (condition === 'showLyonsPrepWorkForm') {
        return !this.forTrader() && this.isRetailEnquiry();
      }

      return true;
    }
  }, {
    key: 'isRetailEnquiry',
    value: function isRetailEnquiry() {
      return this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.New || this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.Used;
    }
  }, {
    key: 'forTrader',
    value: function forTrader() {
      return this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader;
    }
  }, {
    key: 'vehicleHasBrand',
    value: function vehicleHasBrand(brand) {
      if (!this.brands) {
        return false;
      }

      var brancToCheck = (0, _lodash.find)(this.brands, function (b) {
        return b.name.toLowerCase() === brand.toLowerCase();
      });

      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
        return o.isSelected;
      });

      if (!selectedVehicle) {
        return false;
      } else {
        return selectedVehicle.vehicle.brandId === brancToCheck.brandId;
      }
    }
  }, {
    key: 'vehicleHasCondition',
    value: function vehicleHasCondition(condition) {
      var selectedVehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
        return o.isSelected;
      });

      if (!selectedVehicle || !selectedVehicle.vehicle) {
        return false;
      } else {
        return selectedVehicle.vehicle.condition === condition;
      }
    }
  }, {
    key: 'viewDns',
    value: function viewDns() {
      this.printService.printMSL_DNS_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMercPerOwnedWarranty',
    value: function viewMercPerOwnedWarranty() {
      this.printService.printMercUsedWarranty_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMercSPA',
    value: function viewMercSPA() {
      this.printService.printMercSPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMercPreOwnedSPA',
    value: function viewMercPreOwnedSPA() {
      this.printService.printMercUsedSPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMercDPA',
    value: function viewMercDPA() {
      this.printService.printMercDPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMSLPreOwnedDPA',
    value: function viewMSLPreOwnedDPA() {
      this.printService.printMslUsedDPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMazdaDPA',
    value: function viewMazdaDPA() {
      this.printService.printMazdaDPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewSkodaDPA',
    value: function viewSkodaDPA() {
      this.printService.printSkodaDPA_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewRf105Form',
    value: function viewRf105Form() {
      this.printService.printRf105Form_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewRf105TradeForm',
    value: function viewRf105TradeForm() {
      this.printService.printRf105TradeForm_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMslBydDpa',
    value: function viewMslBydDpa() {
      this.printService.printMslBydDpa_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewOrderConfirmation',
    value: function viewOrderConfirmation() {
      this.printService.printOrderConfirmation_Customer(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewCunninghamOrderForm',
    value: function viewCunninghamOrderForm() {
      this.printService.printCunninghamOrderForm_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewDistanceSellingAddendum',
    value: function viewDistanceSellingAddendum() {
      this.printService.printDistanceSellingAddendum_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewDistanceSellingAddendum',
    value: function viewDistanceSellingAddendum() {
      this.printService.printDistanceSellingAddendum_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMSL_PCP',
    value: function viewMSL_PCP() {
      this.printService.printMSL_PCP_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMslPreOwnedWarrantyAgreement',
    value: function viewMslPreOwnedWarrantyAgreement() {
      this.printService.printMslPreOwnedWarrantyAgreement(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewMslXpengDpa',
    value: function viewMslXpengDpa() {
      this.printService.printMslXpengDpa_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewSuzukiDataForm',
    value: function viewSuzukiDataForm() {
      this.printService.printSuzukiDataForm_CustomForm(this.enquiry.enquiryId);
    }
  }, {
    key: 'viewLyonsPrepWorkForm',
    value: function viewLyonsPrepWorkForm() {
      this.printService.printLyonsPrepWorkForm_CustomForm(this.enquiry.enquiryId);
    }
  }]);
  return CustomFormsController;
}();

exports.default = CustomFormsController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/customForms/customForms.controller.js